module.exports = __webpack_public_path__ + "static/media/wrench.caf01d6e.svg";